<template>
  <Paystack
    v-if="gateway === 'paystack'"
    ref="paystack"
    :amount="amount"
    :email="data.email"
    :firstname="data.first_name"
    :lastname="data.last_name"
    :metadata="paymentMeta"
    :paystackkey="paystackKey"
    :reference="reference"
    :channels="channels"
    :currency="currency"
    :callback="callback"
    :close="close"
    :embed="false"
  />
</template>

<script type="text/javascript">
import Paystack from 'vue-paystack'

export default {
  name: 'WalletPaymentGateway',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: true
    },
    gateway: {
      type: String,
      required: true
    },
    saveCard: {
      type: Boolean,
      required: true
    },
    location: {
      type: String,
      required: true
    }
  },
  components: {
    Paystack
  },
  data () {
    return {
      paystackKey: process.env.VUE_APP_PAYSTACK_KEY,
      raveKey: process.env.VUE_APP_RAVE_KEY
    }
  },
  computed: {
    paymentMeta () {
      return {
        custom_fields: JSON.parse(this.data.break_down)
      }
    },
    raveMeta () {
      return {
        email: this.data.email,
        name: `${this.data.first_name} ${this.data.last_name ? this.data.last_name : ''}`,
        phone_number: JSON.stringify(this.paymentMeta)
      }
    },
    amount () {
      return this.gateway === 'paystack' ? this.data.amount * 100 : this.data.amount
    },
    currency () {
      return this.location === 'NG' ? 'NGN' : 'KES'
    },
    channels () {
      if (this.gateway === 'paystack') {
        return this.location === 'NG' ? ['card', 'bank_transfer'] : ['card', 'mobile_money']
      } else {
        return 'card'
      }
    },
    reference () {
      const date = new Date()
      const fullDate = `${date.getDate()}${date.getMonth() + 1}${date.getHours()}${date.getMinutes()}`
      return `EDEN-PAYMENT-${fullDate}`
    }
  },
  methods: {
    callback (response) {
      if (response.status === 'success') {
        this.close(true)
      }
    },
    close (successStatus) {
      this.$emit('close', !!successStatus)
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.gateway === 'paystack' ? this.$refs.paystack.$el.click() : this.$refs.rave.$el.click()
      }
    }
  }
}
</script>
<style scoped>
.payButton,
button {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
</style>
